/**!
 * Apricot
 * @version 4.2.0
 * @author Mitra Assadi, Nathan Henry
 * @license
 * Copyright (c) 2020 The College Board
 */

/* ========================================================================
 * Apricot's Base
 * ======================================================================== */

// SCSS
import '../scss/includes/apricot-base.scss';

window.cb = window.cb || {};
window.cb.apricot = window.cb.apricot || {};
window.cb.apricot.version = '4.2.0';

// javaScript
export default {};
